import { CalculationModel } from "../clients/KompasApi";
import { Collapsable } from "../elements/Collapsable";
import { EnergyDisplay } from "../elements/EnergyDisplay";
import { InfoPopover } from "./InfoPopover";

type Props = {
  calculation: CalculationModel | undefined;
};

export function ResidenceEnergyBlock({ calculation }: Props) {
  if (!calculation) return <Collapsable title="Energie" />;

  return (
    <Collapsable title="Energie">
      {calculation.yearlyCO2Emission ? (
        <EnergyDisplay
          baseValue={calculation.yearlyCO2Emission}
          dataKey="co2Emission"
        />
      ) : null}
      {calculation.yearlyElectricityConsumption ? (
        <>
          <EnergyDisplay
            baseValue={calculation.yearlyElectricityConsumption}
            dataKey="electricityConsumption"
          />
          {!!(
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            (
              calculation.buildingRelatedElectricityConsumption ||
              // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
              calculation.householdElectricityConsumption ||
              calculation.sustainableEnergyGeneration
            )
          ) && (
            <InfoPopover size="2xs">
              <ul>
                {!!calculation.buildingRelatedElectricityConsumption && (
                  <li>
                    Gebouwgebonden elektra verbruik:{" "}
                    {calculation.buildingRelatedElectricityConsumption} kWh/jaar
                  </li>
                )}
                {!!calculation.householdElectricityConsumption && (
                  <li>
                    Huishoudelijk elektra verbruik:{" "}
                    {calculation.householdElectricityConsumption} kWh/jaar
                  </li>
                )}
                {!!calculation.sustainableEnergyGeneration && (
                  <li>
                    Duurzame energie opwekking:{" "}
                    {calculation.sustainableEnergyGeneration} kWh/jaar
                  </li>
                )}
              </ul>
            </InfoPopover>
          )}
        </>
      ) : null}
      {calculation.yearlyGasConsumption ? (
        <EnergyDisplay
          baseValue={calculation.yearlyGasConsumption}
          dataKey="gasConsumption"
        />
      ) : null}
      {/* {calculation.heatNetworkUsage ? (
        <EnergyDisplay
          baseValue={calculation.heatNetworkUsage}
          dataKey="heatNetworkConsumption"
        />
      ) : null} */}
    </Collapsable>
  );
}
